import { Colors } from '../../../../../themes/colors';
import { MultiCheckboxGroup } from '../../../../commonComponents/MultiCheckboxGroup';
import {
  benefitsOptions,
  compensationOptions,
  CompensationType,
  payTypeOptions,
} from '../../shared/constants';
import { FormCard } from '../../shared/FormCard';
import { FormField } from '../../shared/FormField';
import { getErrorStyle, getPayRateSuffix } from '../../shared/utils';

export const CompensationBenefitsCard = ({ formValues, handleChange, errorStatus }) => {
  return (
    <FormCard
      title="Compensation and Benefits"
      style={{ marginTop: 16 }}
      contentStyle={{ width: '80%' }}
    >
      <div style={{ display: 'flex', gap: 16, marginTop: 18 }}>
        <FormField label="Pay Type" style={{ width: 200 }} required>
          <select
            className="custom-select custom-select-lg"
            style={{ height: 32, ...getErrorStyle(errorStatus?.invalidPayType) }}
            value={formValues.payType}
            onChange={(val) => handleChange('payType', val.target.value)}
          >
            {payTypeOptions.map((option) => (
              <option key={option.code} value={option.code}>
                {option.name}
              </option>
            ))}
          </select>
        </FormField>

        <FormField label="Compensation" style={{ width: 200 }} required>
          <select
            className="custom-select custom-select-lg"
            style={{ height: 32, ...getErrorStyle(errorStatus?.invalidCompensationType) }}
            value={formValues.compensationType}
            onChange={(val) => handleChange('compensationType', val.target.value)}
          >
            <option value="" disabled>
              Select Compensation Type
            </option>
            {compensationOptions.map((option) => (
              <option key={option.code} value={option.code}>
                {option.name}
              </option>
            ))}
          </select>
        </FormField>
      </div>

      {formValues.compensationType ? (
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <FormField
            label={`Stated Pay${formValues.compensationType === CompensationType.RANGE ? ' Range' : ''}`}
            required
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <input
                className="form-control"
                type="number"
                placeholder="$"
                style={{ width: 105, ...getErrorStyle(errorStatus?.invalidMinRate) }}
                value={formValues.minRate}
                onChange={(e) => handleChange('minRate', e.target.value.replace(/[^0-9]/g, ''))}
              />
              {formValues.compensationType === CompensationType.RANGE && (
                <>
                  <span style={{ alignSelf: 'center' }}> - </span>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="$"
                    style={{ width: 105, ...getErrorStyle(errorStatus?.invalidMaxRate) }}
                    value={formValues.maxRate}
                    onChange={(e) => handleChange('maxRate', e.target.value.replace(/[^0-9]/g, ''))}
                  />
                </>
              )}
              <span style={{ alignSelf: 'center', marginLeft: -5 }}>
                {getPayRateSuffix(formValues.payType)}
              </span>
            </div>
          </FormField>
        </div>
      ) : null}

      <div style={{ height: 1, backgroundColor: Colors.neutral_200 }} />

      <FormField label="Benefits">
        <MultiCheckboxGroup
          options={benefitsOptions.map((option) => ({
            label: option.name,
            value: option.code,
          }))}
          selectedValues={formValues.benefits}
          onChange={(updated) => handleChange('benefits', updated)}
        />
        {formValues.benefits.includes('Other') && (
          <FormField label="Enter any other benefits below:">
            <textarea
              className="form-control"
              id="postTextArea"
              maxLength={100}
              placeholder="Enter other benefits here"
              rows="3"
              value={formValues.benefitsOther}
              onChange={(e) => handleChange('benefitsOther', e.target.value)}
            />
          </FormField>
        )}
      </FormField>
    </FormCard>
  );
};
